/* eslint-disable */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT!
import * as Urql from 'urql';

import type * as Types from '../../../../../../../../../../../generated/graphql/types';

export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type DeliveryOfferV2QueryVariables = Types.Exact<{
  platform: Types.Platform;
  market: Types.Market;
  isMf: Types.Scalars['Boolean']['input'];
  productId: Types.Scalars['Int']['input'];
  sellerId: Types.Scalars['Int']['input'];
  sku: Types.Scalars['String']['input'];
  quantity: Types.Scalars['Int']['input'];
  amount: Types.Scalars['Float']['input'];
  currency: Types.Scalars['String']['input'];
  weight: Types.Scalars['Float']['input'];
}>;

export type DeliveryOfferV2Query = { __typename?: 'Query' } & {
  deliveryOfferV2: Types.Maybe<
    Array<
      Types.Maybe<
        { __typename?: 'DeliveryOffer' } & Pick<
          Types.DeliveryOffer,
          'mode' | 'name' | 'deliveryCountries'
        > & {
            estimateDelivery: { __typename?: 'EstimatedDelivery' } & Pick<
              Types.EstimatedDelivery,
              'isExpress' | 'isBestDeliveryOffer'
            > & {
                deliveryTime: { __typename?: 'DeliveryTime' } & Pick<
                  Types.DeliveryTime,
                  'min' | 'max' | 'orderBefore' | 'expressMode'
                >;
                price: { __typename?: 'DeliveryPrice' } & Pick<
                  Types.DeliveryPrice,
                  'amount' | 'currency'
                >;
              };
          }
      >
    >
  >;
};

export const DeliveryOfferV2Document = /*#__PURE__*/ `
    query DeliveryOfferV2($platform: Platform!, $market: Market!, $isMf: Boolean!, $productId: Int!, $sellerId: Int!, $sku: String!, $quantity: Int!, $amount: Float!, $currency: String!, $weight: Float!) {
  deliveryOfferV2(
    platform: $platform
    market: $market
    isMf: $isMf
    productId: $productId
    sellerId: $sellerId
    sku: $sku
    quantity: $quantity
    amount: $amount
    currency: $currency
    weight: $weight
  ) {
    mode
    name
    deliveryCountries
    estimateDelivery {
      isExpress
      deliveryTime {
        min
        max
        orderBefore
        expressMode
      }
      price {
        amount
        currency
      }
      isBestDeliveryOffer
    }
  }
}
    `;

export function useDeliveryOfferV2Query(
  options: Omit<Urql.UseQueryArgs<DeliveryOfferV2QueryVariables>, 'query'>,
) {
  return Urql.useQuery<DeliveryOfferV2Query, DeliveryOfferV2QueryVariables>({
    query: DeliveryOfferV2Document,
    ...options,
  });
}
